// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/payment/v2/payment_api.proto (package gdx.gateway.web.payment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ActivateBoosterRequest, ActivateBoosterResponse, ActivateSubscriptionRequest, ActivateSubscriptionResponse, ApplyFreePackageRequest, ApplyFreePackageResponse, CancelPremiumRequest, CancelPremiumResponse, ChangeSubscriptionPackageRequest, ChangeSubscriptionPackageResponse, CompleteOffersRequest, CompleteOffersResponse, GetBillingHistoryRequest, GetBillingHistoryResponse, GetCreditsBalanceRequest, GetCreditsBalanceResponse, GetFreeCreditsFeaturesStatusRequest, GetFreeCreditsFeaturesStatusResponse, GetPackageRequest, GetPackageResponse, GetPaymentMethodRequest, GetPaymentMethodResponse, GetPaymentOrderStatusRequest, GetPaymentOrderStatusResponse, GetRecommendedSubscriptionPackageRequest, GetRecommendedSubscriptionPackageResponse, GetSolidAuthorizeFormRequest, GetSolidAuthorizeFormResponse, GetSolidPaymentFormRequest, GetSolidPaymentFormResponse, GetSubscriptionStatusRequest, GetSubscriptionStatusResponse, InitiatePayPalPaymentRequest, InitiatePayPalPaymentResponse, ListBoostersRequest, ListBoostersResponse, ListCreditsPackagesRequest, ListCreditsPackagesResponse, ListLimitedOfferPackagesRequest, ListLimitedOfferPackagesResponse, ListOffboardingPackagesRequest, ListOffboardingPackagesResponse, ListPackagesRequest, ListPackagesResponse, ListPaymentCardsRequest, ListPaymentCardsResponse, ListPaymentMethodsRequest, ListPaymentMethodsResponse, ListPopUpPromoPackagesRequest, ListPopUpPromoPackagesResponse, ListPremiumGoldPackagesRequest, ListPremiumGoldPackagesResponse, ListPremiumPackagesRequest, ListPremiumPackagesResponse, ListPromoCreditsPackagesRequest, ListPromoCreditsPackagesResponse, ListSuspensionPeriodsRequest, ListSuspensionPeriodsResponse, PayByCardIDRequest, PayByCardIDResponse, RemovePaymentCardRequest, RemovePaymentCardResponse, SetCreditsAutorefillRequest, SetCreditsAutorefillResponse, SetPreferredPaymentCardRequest, SetPreferredPaymentCardResponse, SuspendSubscriptionRequest, SuspendSubscriptionResponse, UnsubscribePremiumRequest, UnsubscribePremiumResponse } from "./payment_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods related to payments and premium features.
 *
 * @generated from service gdx.gateway.web.payment.v2.PaymentAPI
 */
export const PaymentAPI = {
  typeName: "gdx.gateway.web.payment.v2.PaymentAPI",
  methods: {
    /**
     * Returns available for purchase premium packages.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPremiumPackages
     */
    listPremiumPackages: {
      name: "ListPremiumPackages",
      I: ListPremiumPackagesRequest,
      O: ListPremiumPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available for purchase premium gold packages.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPremiumGoldPackages
     */
    listPremiumGoldPackages: {
      name: "ListPremiumGoldPackages",
      I: ListPremiumGoldPackagesRequest,
      O: ListPremiumGoldPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available credit packages.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListCreditsPackages
     */
    listCreditsPackages: {
      name: "ListCreditsPackages",
      I: ListCreditsPackagesRequest,
      O: ListCreditsPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available promo subscriptions.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPopUpPromoPackages
     */
    listPopUpPromoPackages: {
      name: "ListPopUpPromoPackages",
      I: ListPopUpPromoPackagesRequest,
      O: ListPopUpPromoPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available promo credits packages.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPromoCreditsPackages
     */
    listPromoCreditsPackages: {
      name: "ListPromoCreditsPackages",
      I: ListPromoCreditsPackagesRequest,
      O: ListPromoCreditsPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available promo subscriptions for offboarding.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListOffboardingPackages
     */
    listOffboardingPackages: {
      name: "ListOffboardingPackages",
      I: ListOffboardingPackagesRequest,
      O: ListOffboardingPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available limited offer packages ( https://gdx.myjetbrains.com/youtrack/issue/GDP-886 ).
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListLimitedOfferPackages
     */
    listLimitedOfferPackages: {
      name: "ListLimitedOfferPackages",
      I: ListLimitedOfferPackagesRequest,
      O: ListLimitedOfferPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns available for purchase boosters.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListBoosters
     */
    listBoosters: {
      name: "ListBoosters",
      I: ListBoostersRequest,
      O: ListBoostersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Tries to activate booster.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ActivateBooster
     */
    activateBooster: {
      name: "ActivateBooster",
      I: ActivateBoosterRequest,
      O: ActivateBoosterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cancels offer and moves to next one if available.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.CompleteOffers
     */
    completeOffers: {
      name: "CompleteOffers",
      I: CompleteOffersRequest,
      O: CompleteOffersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns payment methods list enabled and available for current user.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPaymentMethods
     */
    listPaymentMethods: {
      name: "ListPaymentMethods",
      I: ListPaymentMethodsRequest,
      O: ListPaymentMethodsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns individual payment method info.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetPaymentMethod
     */
    getPaymentMethod: {
      name: "GetPaymentMethod",
      I: GetPaymentMethodRequest,
      O: GetPaymentMethodResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns url for SOLID payment form.
     * Returns FAILED_PRECONDITION errors:
     * - other operation in progress
     * - already subscribed
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetSolidPaymentForm
     */
    getSolidPaymentForm: {
      name: "GetSolidPaymentForm",
      I: GetSolidPaymentFormRequest,
      O: GetSolidPaymentFormResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates payment process using stored SOLID token.
     * Returns FAILED_PRECONDITION errors:
     * - other operation in progress
     * - already subscribed
     * Returns NOT_FOUND - token not found if there is no active card tokens
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.PayByCardID
     */
    payByCardID: {
      name: "PayByCardID",
      I: PayByCardIDRequest,
      O: PayByCardIDResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates payPal payment process.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.InitiatePayPalPayment
     */
    initiatePayPalPayment: {
      name: "InitiatePayPalPayment",
      I: InitiatePayPalPaymentRequest,
      O: InitiatePayPalPaymentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Applies a free package to users profile.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ApplyFreePackage
     */
    applyFreePackage: {
      name: "ApplyFreePackage",
      I: ApplyFreePackageRequest,
      O: ApplyFreePackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns users billing history.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetBillingHistory
     */
    getBillingHistory: {
      name: "GetBillingHistory",
      I: GetBillingHistoryRequest,
      O: GetBillingHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Add payment card to user account.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetSolidAuthorizeForm
     */
    getSolidAuthorizeForm: {
      name: "GetSolidAuthorizeForm",
      I: GetSolidAuthorizeFormRequest,
      O: GetSolidAuthorizeFormResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Remove payment card from user account.
     * When there is only one card left returns a FAILED_PRECONDITION error code
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.RemovePaymentCard
     */
    removePaymentCard: {
      name: "RemovePaymentCard",
      I: RemovePaymentCardRequest,
      O: RemovePaymentCardResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List all user's payment cards.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPaymentCards
     */
    listPaymentCards: {
      name: "ListPaymentCards",
      I: ListPaymentCardsRequest,
      O: ListPaymentCardsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets preferred payment card.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.SetPreferredPaymentCard
     */
    setPreferredPaymentCard: {
      name: "SetPreferredPaymentCard",
      I: SetPreferredPaymentCardRequest,
      O: SetPreferredPaymentCardResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates change of prolongation subscription package.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ChangeSubscriptionPackage
     */
    changeSubscriptionPackage: {
      name: "ChangeSubscriptionPackage",
      I: ChangeSubscriptionPackageRequest,
      O: ChangeSubscriptionPackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Unsubscribes user from premium prolongation.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.UnsubscribePremium
     */
    unsubscribePremium: {
      name: "UnsubscribePremium",
      I: UnsubscribePremiumRequest,
      O: UnsubscribePremiumResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Cancels premium prolongation and remaining premium days.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.CancelPremium
     */
    cancelPremium: {
      name: "CancelPremium",
      I: CancelPremiumRequest,
      O: CancelPremiumResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get subscription status.
     * If a resulting package price if greater than 0 FAILED_PRECONDITION error code will be returned
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetSubscriptionStatus
     */
    getSubscriptionStatus: {
      name: "GetSubscriptionStatus",
      I: GetSubscriptionStatusRequest,
      O: GetSubscriptionStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get recommended next subscription package for user.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetRecommendedSubscriptionPackage
     */
    getRecommendedSubscriptionPackage: {
      name: "GetRecommendedSubscriptionPackage",
      I: GetRecommendedSubscriptionPackageRequest,
      O: GetRecommendedSubscriptionPackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns current status details about order.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetPaymentOrderStatus
     */
    getPaymentOrderStatus: {
      name: "GetPaymentOrderStatus",
      I: GetPaymentOrderStatusRequest,
      O: GetPaymentOrderStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns credits balance for current user.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetCreditsBalance
     */
    getCreditsBalance: {
      name: "GetCreditsBalance",
      I: GetCreditsBalanceRequest,
      O: GetCreditsBalanceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Whether we can refill credits automatically.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.SetCreditsAutorefill
     */
    setCreditsAutorefill: {
      name: "SetCreditsAutorefill",
      I: SetCreditsAutorefillRequest,
      O: SetCreditsAutorefillResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Suspends subscription until specified date.
     * returns FAILED_PRECONDITION error if subscription is inactive.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.SuspendSubscription
     */
    suspendSubscription: {
      name: "SuspendSubscription",
      I: SuspendSubscriptionRequest,
      O: SuspendSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Activates suspended subscription.
     * returns FAILED_PRECONDITION error if subscription is inactive.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ActivateSubscription
     */
    activateSubscription: {
      name: "ActivateSubscription",
      I: ActivateSubscriptionRequest,
      O: ActivateSubscriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists info about provided packages.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListPackages
     */
    listPackages: {
      name: "ListPackages",
      I: ListPackagesRequest,
      O: ListPackagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Check what features are available for free usage.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetFreeCreditsFeaturesStatus
     */
    getFreeCreditsFeaturesStatus: {
      name: "GetFreeCreditsFeaturesStatus",
      I: GetFreeCreditsFeaturesStatusRequest,
      O: GetFreeCreditsFeaturesStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List available suspension periods for user.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.ListSuspensionPeriods
     */
    listSuspensionPeriods: {
      name: "ListSuspensionPeriods",
      I: ListSuspensionPeriodsRequest,
      O: ListSuspensionPeriodsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns a single package with promotion.
     *
     * @generated from rpc gdx.gateway.web.payment.v2.PaymentAPI.GetPackage
     */
    getPackage: {
      name: "GetPackage",
      I: GetPackageRequest,
      O: GetPackageResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

